/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HousingOrgRole } from '../models/HousingOrgRole';
import type { HousingOrgRoleName } from '../models/HousingOrgRoleName';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class HousingOrgRolesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns HousingOrgRoleName OK
     * @throws ApiError
     */
    public getMyHousingOrgRoles(): CancelablePromise<Record<string, Array<HousingOrgRoleName>>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/HousingOrgRoles/GetMyHousingOrgRoles',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get all the login roles for users in a housing org, by the sysorg guid. Users with any role in this system org can call this API, and they can only see roles for this org.
     * @param sysOrgGuid
     * @returns HousingOrgRole OK
     * @throws ApiError
     */
    public getHousingOrgRoles(
        sysOrgGuid: string,
    ): CancelablePromise<Record<string, Array<HousingOrgRole>>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/HousingOrgRoles/{sysOrgGuid}/GetHousingOrgRoles',
            path: {
                'sysOrgGuid': sysOrgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param sysOrgGuid
     * @param userGuid
     * @param requestBody
     * @returns boolean OK
     * @throws ApiError
     */
    public updateHousingOrgRoles(
        sysOrgGuid: string,
        userGuid: string,
        requestBody?: Array<HousingOrgRole>,
    ): CancelablePromise<boolean> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/HousingOrgRoles/{sysOrgGuid}/{userGuid}/UpdateHousingOrgRoles',
            path: {
                'sysOrgGuid': sysOrgGuid,
                'userGuid': userGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
